import { decodeShortId } from './decodeId';

/**
 * Format 16 bytes as a hyphenated UUID string WITHOUT validating the RFC
 * version/variant bits. Postgres `uuid` columns (and Laravel's `uuid` rule)
 * accept any 128-bit value, so ids whose version nibble isn't 1-8 are still
 * legitimate. The `uuid` package's `stringify` rejects those, which would make
 * lengthenId silently return the short id unchanged and break round-tripping.
 */
function bytesToUuid(bytes: Uint8Array): string {
  let hex = '';
  for (const byte of bytes) {
    hex += byte.toString(16).padStart(2, '0');
  }
  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20, 32),
  ].join('-');
}

export function lengthenId(id: string): string {
  try {
    const bytes = decodeShortId(id);
    if (bytes.length !== 16) return id;
    return bytesToUuid(bytes);
  } catch {
    return id;
  }
}
